import { Outlet } from "react-router-dom";
import Navbar from "../navbar/Navbar";
// import Footer from "../components/Footer"; // Əgər varsa

function PageLayout() {
  return (
    <>
      <Navbar />
      <main style={{ minHeight: "80vh"}}>
        <Outlet />
      </main>
      {/* <Footer /> */}
    </>
  );
}

export default PageLayout;
